import { I18n } from '@calendly/i18n'
import { Table, Header, Body, HeaderCell, BatchCheckbox } from '@calendly/table'
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { Pagination } from './pagination'

const batchCheckboxStatus = (selectedRows, rows) => {
  if (selectedRows.length === 0) return 'none'
  if (selectedRows.length === rows.length) return 'all'
  return 'some'
}

export const TableElement = ({
  columns,
  events = [],
  setSelectedRowsState,
  selectedRows,
  selectableRows,
  setSelectedRows,
  pagination,
  children,
}) => {
  const selectableRowsOrEvents = selectableRows || events
  const toggleSelectedRows = () => {
    if (selectedRows.length === selectableRowsOrEvents.length) {
      setSelectedRows([])
    } else {
      const newArray = [...selectableRowsOrEvents.map((row) => row.id)]
      setSelectedRows(newArray)
    }
  }

  useEffect(() => {
    if (setSelectedRowsState) {
      setSelectedRowsState(selectedRows)
    }
  }, [selectedRows, setSelectedRowsState])

  return (
    <>
      <Table>
        <Header>
          <HeaderCell>
            <BatchCheckbox
              status={batchCheckboxStatus(selectedRows, selectableRowsOrEvents)}
              onChange={() => toggleSelectedRows()}
            />
          </HeaderCell>
          {columns.map((column) => <HeaderCell key={column}>{column}</HeaderCell>)}
          <HeaderCell>
            <VisuallyHidden>{I18n.t('publisher.components.table.quick_action')}</VisuallyHidden>
          </HeaderCell>
          <HeaderCell hugContent>
            <VisuallyHidden>{I18n.t('publisher.components.table.action_menu')}</VisuallyHidden>
          </HeaderCell>
        </Header>
        <Body>
          {children}
        </Body>
      </Table>
      {pagination && <Pagination pagination={pagination} />}
    </>
  )
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
  events: PropTypes.arrayOf(PropTypes.objectOf({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    bookingUrl: PropTypes.string.isRequired,
  })),
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    nextPage: PropTypes.number,
    prevPage: PropTypes.number,
    limitValue: PropTypes.number,
    totalCount: PropTypes.number,
    totalPage: PropTypes.number,
  }),
}
